export default (domain, libraryServicesApi) => {
    const library = {}
    const { isOnLocalhost, addApiPrefix } = libraryServicesApi

    library.getOauthServerDomain = () => {
        return isOnLocalhost() ? domain : addApiPrefix(domain)
    }

    return library
}
